import { FC } from 'react'

import { PwaInstallGuide } from 'handlers/getPwaInstallGuide'

import {
  GuideDialog,
  GuideDialogActions,
  GuideDialogContent,
  GuideDialogTitle,
  GuideEnvironmentBadge,
  GuideIntroduction,
  GuideNotesList,
  GuidePrimaryButton,
  GuideSecondaryButton,
  GuideStepsList,
} from './InstallPwaGuideModal.styles'

/**
 * Пропсы модалки инструкции установки PWA.
 * @param open — открыта ли модалка
 * @param guide — текст под текущее окружение
 * @param canUseNativeInstall — доступен beforeinstallprompt
 * @param onClose — закрытие
 * @param onNativeInstall — системный диалог установки (если есть)
 */
export type InstallPwaGuideModalProps = {
  open: boolean
  guide: PwaInstallGuide
  canUseNativeInstall: boolean
  onClose: () => void
  onNativeInstall?: () => void
}

/**
 * Всплывающее окно с пошаговой установкой админки как приложения.
 */
const InstallPwaGuideModal: FC<InstallPwaGuideModalProps> = ({
  open,
  guide,
  canUseNativeInstall,
  onClose,
  onNativeInstall,
}) => {
  return (
    <GuideDialog open={open} onClose={onClose} aria-labelledby='pwa-install-guide-title'>
      <GuideDialogTitle id='pwa-install-guide-title'>{guide.title}</GuideDialogTitle>
      <GuideDialogContent>
        <GuideEnvironmentBadge>{guide.environmentLabel}</GuideEnvironmentBadge>
        <GuideIntroduction>{guide.introduction}</GuideIntroduction>
        <GuideStepsList>
          {guide.steps.map((stepText) => (
            <li key={stepText}>{stepText}</li>
          ))}
        </GuideStepsList>
        {guide.notes?.length > 0 ? (
          <GuideNotesList>
            {guide.notes.map((noteText) => (
              <li key={noteText}>{noteText}</li>
            ))}
          </GuideNotesList>
        ) : null}
      </GuideDialogContent>
      <GuideDialogActions>
        {canUseNativeInstall && onNativeInstall ? (
          <GuidePrimaryButton type='button' onClick={onNativeInstall}>
            Установить сейчас
          </GuidePrimaryButton>
        ) : null}
        <GuideSecondaryButton type='button' onClick={onClose}>
          Понятно
        </GuideSecondaryButton>
      </GuideDialogActions>
    </GuideDialog>
  )
}

export default InstallPwaGuideModal
